import { element } from 'protractor';

import { Component, OnInit, AfterViewInit, LOCALE_ID, Inject, ViewChild, ElementRef } from '@angular/core';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Rx';

import { LoginService } from './login.service';
//import { IUser } from './user';
//import { AppSettings } from "../shared/app-settings";

import { IMyOptions } from 'mydatepicker';
import { CustomValidators } from 'ng2-validation';
import { DateService } from './../shared/date.service';
import 'assets/TlvBaseJs';

import '@progress/kendo-angular-intl/locales/he/all';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { SpinnerService } from 'app/shared/spinner/spinner.service';
import { NofeshService } from '../nofesh/nofesh.service';
import { INofesh } from '../nofesh/model/nofesh';
import { NofshonimService } from '../nofshonim-chul/nofshonim.service';
import { forkJoin } from 'rxjs';
import { ConfigService } from 'app/shared/config.service';
import { stringify } from '@angular/core/src/util';
import { reject } from 'q';
import { ConstantPool } from '@angular/compiler/src/constant_pool';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { environment } from 'environments/environment';
import { INofeshSelected } from 'app/shared/interfaces/Inofesh-selected.interface';
import { IUser } from './user';
import { HttpErrorResponse } from '@angular/common/http';

declare var grecaptcha: any;
declare var jQuery: any;
declare var reloadCaptcha: any;

const NOFESH_HOME_URL: string = "/nofesh/home";

@Component({
    moduleId: module.id,
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [LoginService]
})
export class LoginComponent implements OnInit {

    minYear: Date = new Date();//= new Date().setDate(t).getFullYear() - 75;
    maxYear: Date = new Date(); //= new Date().getFullYear() - 16;

    header: string = "הזדהות";
    isAdmin: boolean = false;

    user: FormGroup;
    isvalidform: boolean = true;
    err_desc: string;
    is_submited: boolean = false;
    returnUrl: string;
    atar_open: boolean = true;
    login_type: number;
    zakaut: number;
    showCaptchaV1: boolean = false;
    googleV3Token: string = "";
    isGoogleTokenValid: boolean = false;
    isFormValidAfterTwoTokensExecuted: boolean = false; //form is valid only if the second token was executed. reCaptcha v3 is executed first to validate againts service
    // and then must be executed again in order to get a new token for going to the server. 
    // you can't take a token already validated with google and validate it again. 

    constructor(
        private route: ActivatedRoute,
        public router: Router,
        private _loginService: LoginService,
        private fb: FormBuilder,
        private ds: DateService,
        @Inject(LOCALE_ID) public localeId: string,
        public intlService: IntlService,
        private userMessagesService: UserMessagesService,
        private spinnerService: SpinnerService,
        private _nofeshService: NofeshService,
        private _nofshonimService: NofshonimService,
        private _configService: ConfigService,
        private _spinnerService: SpinnerService
    ) { }

    ngOnInit() {

        this.userMessagesService.clearAll();

        if (environment.production) {
            this.logPprServer();
        }

        // setTimeout(_ => {
        //     jQuery("#captchaUserText").off();
        // },0)
        //     console.log("before recaptcha")

        //     this.getRecaptcha().then((token:string)=>{

        //         console.log('token1',token);
        //         this._loginService.validateRecaptchav3(token).subscribe(res=>{

        //                 //if the result is true(meaning I'm not a robot) then I need to create a new token before going to the server.
        //                 //The reason is that checking again in the server is a must(according to Yaron Hakun) , and Google does not allow checking whether I'm a robot or not twice with the same token.
        //                 if(res)
        //                 {
        //                     this.isGoogleTokenValid = true;
        //                     this.getRecaptcha().then((token:string)=>{
        //                         console.log('token2',token)
        //                         this.googleV3Token = token;
        //                         this.spinnerService.hideSpinner();
        //                         this.isFormValidAfterTwoTokensExecuted = true;
        //                         debugger;
        //                     });
        //                 }

        //                 if(!res)
        //                 {

        //                     //reload captcha v1 in case that Google identify the user as robot
        //                     // in case captcha is not loaded reload capcha
        //                     this.showCaptchaV1 = true;
        //                     this.isGoogleTokenValid = false;
        //                     if (!jQuery(".captcha-main-image")[0])
        //                     {
        //                         reloadCaptcha();
        //                     }

        //                     //change the children of myCapcha from md-5 to md-12 in order to fit new screen
        //                     document.getElementById('myCapcha').children[0].attributes[0].nodeValue = "form-group col-xs-12 col-sm-12 col-md-12 required TlvContainerCapcha";
        //                     this.spinnerService.hideSpinner();
        //                     this.isFormValidAfterTwoTokensExecuted = true;

        //                 }

        //         })

        // });

        this.showCaptchaV1 = true;
        this.isGoogleTokenValid = false;
        if (!jQuery(".captcha-main-image")[0]) {
            reloadCaptcha();
        }

        const captchaElement = document.querySelector(".TlvContainerCapcha");
        if (captchaElement) {
            captchaElement.classList.replace("col-md-5", "col-md-12");
        }
        this.isFormValidAfterTwoTokensExecuted = true;


        if (this.route.snapshot.routeConfig.path.includes("admin")) {
            this.header = "הזדהות מנהל מערכת";
            this.isAdmin = true;
        }

        this.localeId = "he-IL";
        (<CldrIntlService>this.intlService).localeId = "he-IL";

        var d = new Date();
        this.maxYear.setFullYear(d.getFullYear() - 16);
        this.minYear.setFullYear(d.getFullYear() - 75);


        // in case captcha is not loaded reload capcha
        // if (!jQuery(".captcha-main-image")[0]){
        //     reloadCaptcha();
        // }

        this._loginService.logout();

        this.user = this.fb.group({
            ms_zehut: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(9), CustomValidators.digits]],
            birthDate: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]]
        });

        this.login_type = 0;
        if (this.route.snapshot.queryParams['nav'] != null && this.route.snapshot.queryParams['nav'] != undefined) {
            var redirect_url = this.route.snapshot.queryParams['nav'];
            if (redirect_url.indexOf("peiluyots") !== -1)
                this.login_type = 1;
            else if (redirect_url.indexOf("nofesh") !== -1) {
                this.login_type = 0;
            }
            else if (redirect_url.indexOf("matanot") !== -1) {
                this.login_type = 2;
            }
        }

        this.returnUrl = this.route.snapshot.queryParams['nav'] || NOFESH_HOME_URL;
    }

    logPprServer() {
        try {
            const server = this._configService.getConfigPropertyByKey("serverForDebug");
            if (server) console.log(server);
        }
        catch { }
    }


    get ms_zehut() { return this.user.get('ms_zehut'); }
    get birthDate() { return this.user.get('birthDate'); }

    login(event, user: any) {
        this.userMessagesService.clearErrorMessage();
        this.userMessagesService.clearErrorMessages();
        this.isvalidform = true;
        this.is_submited = true;
        event.preventDefault();

        let captchatext = jQuery("#captchaUserText").val();
        let capuid = jQuery("#capuid").val();

        this._loginService.getLogin(this.user.value.ms_zehut, this.ds.formatDate(this.user.value.birthDate), captchatext, capuid, this.login_type)
            .subscribe((response: IUser) => {
                localStorage.clear();
                sessionStorage.clear();

                this.isvalidform = true;
                let expireDate = new Date(new Date().getTime() + (1000 * response.expires_in));
                let tokenObj = { 'token': response.access_token, 'expires': expireDate, 'role': response.role }

                localStorage.setItem('token', JSON.stringify(tokenObj));
                localStorage.setItem('ms_zehut_mazmin', JSON.stringify(this.user.value.ms_zehut));

                if (response.role == 1 && this.isAdmin) {
                    this.router.navigateByUrl("/admin");
                    return;
                }
                else if (response.role != 1 && this.isAdmin) {
                    this.userMessagesService.setErrorMessage("ארעה שגיאה. נא לבצע כניסה מחדש");
                    window.location.href = "";
                }
                else {
                    if (this.login_type == 0) {
                        this._spinnerService.showSpinner();
                        this.getNofeshimAndUserSelectedNofesh()
                            .subscribe((nofashimAndUserSelectedNofesh: [ResultOfOperation<INofesh[]>, INofeshSelected]) => {
                                if (!nofashimAndUserSelectedNofesh || !nofashimAndUserSelectedNofesh[0] || !nofashimAndUserSelectedNofesh[0].data || !nofashimAndUserSelectedNofesh[1]) {
                                    this.is_submited = false;
                                    let missingData;
                                    if (!nofashimAndUserSelectedNofesh) {
                                        missingData = "data from server";
                                    }
                                    else if (!nofashimAndUserSelectedNofesh[0] || !nofashimAndUserSelectedNofesh[0].data) {
                                        missingData = "nofashim";
                                    }
                                    else if (!nofashimAndUserSelectedNofesh[1]) {
                                        missingData = "user data";
                                    }
                                    console.error(`Failed to get ${missingData}`);
                                    this.userMessagesService.setErrorMessage("ארעה שגיאה בעת טעינת הנתונים. נא לנסות שוב");
                                    return;
                                }

                                const nofashim = nofashimAndUserSelectedNofesh[0].data;
                                const userSelectedNofesh = nofashimAndUserSelectedNofesh[1];
                                sessionStorage.setItem("nofashim", JSON.stringify(nofashim));
                                sessionStorage.setItem("userSelectedNofesh", JSON.stringify(userSelectedNofesh));

                                sessionStorage.setItem("navigatedFromLogin", "true");
                                this._spinnerService.hideSpinner();
                                this.router.navigateByUrl(this.returnUrl);
                            },
                                (error) => {
                                    this._spinnerService.hideSpinner();
                                    this.is_submited = false;
                                    this.userMessagesService.setErrorMessage("אירעה שגיאה בעת טעינת הנתונים. נא לנסות שוב");
                                }
                            );
                    }
                    else {
                        this.router.navigateByUrl(this.returnUrl);
                    }
                }
            },
                (error: HttpErrorResponse) => {
                    this.isvalidform = false;
                    this.is_submited = false;
                    this.spinnerService.hideSpinner();

                    if (error.hasOwnProperty("error") && error.error.error_description && error.error.error === "auth_error") {
                        this.userMessagesService.setErrorMessage(error.error.error_description);
                    }
                    else {
                        this.userMessagesService.setErrorMessage("אירעה שגיאה בכניסה למערכת");
                    }
                });
    }

    private getNofeshimAndUserSelectedNofesh() {
        // Getting all nofashim and user selected nofesh after they cleared from storage.
        let nofashim = this._nofeshService.getAllNofashim();
        let userSelectedNofesh = this._nofeshService.getUserSelectedNofesh(-1);
        return forkJoin([nofashim, userSelectedNofesh]);
    }

    clearDate(): void {
        // Clear the date using the setValue function
        this.user.setValue({ birthDate: '' });
    }




    async getAndVarifyCaptchaToken() {
        let isVerified: boolean = false;
        let tokenCallback = this.getGoogleRecaptchav3Token();
        return await tokenCallback.then(function (token) {
            return token;
        });

    }




    async getGoogleRecaptchav3Token() {
        let reCaptchav3SiteKey = this._configService.getConfigPropertyByKey("reCaptchav3SiteKey");
        return await grecaptcha.execute(reCaptchav3SiteKey, { action: 'homepage' });




        /*
        let googleTokenVerfied:boolean = undefined;            
        let self = this;
        grecaptcha.ready(function(){
             grecaptcha.execute(reCaptchav3SiteKey, {action: 'homepage'}).then(function(token) {

             });
        });
        */


    }

    getRecaptcha() {
        let reCaptchav3SiteKey = this._configService.getConfigPropertyByKey("reCaptchav3SiteKey");
        return new Promise((resolve, reject) => {
            try {
                grecaptcha.ready(function () {
                    grecaptcha.execute(reCaptchav3SiteKey, { action: 'homepage' }).then((token) => {
                        return resolve(token);
                    })
                })
            }
            catch (e) {
                console.log("grecaptcha error:", e)
                return reject("exception")
            }

        })
    }



}
